import { Component, Input } from '@angular/core';
import { getCustomerStatus } from '@innogy/customer/store';
import type { InnogyComponentRendering } from '@core/jss-models';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { MijnInformationBlockComponent } from '../mijn-information-block.component';

@Component({
  selector: 'wl-mijn-information-block-container',
  templateUrl: './mijn-information-block-container.component.html',
  styleUrls: ['./mijn-information-block-container.component.scss'],
  standalone: true,
  imports: [MijnInformationBlockComponent, CSCaptureDirective, AsyncPipe],
})
export class MijnInformationBlockContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;
  readonly customerStatus$ = this.store$.select(getCustomerStatus);

  constructor(private readonly store$: Store<any>) {}
}
